import React from 'react';
import { Skeleton } from 'primereact/skeleton';
import { useToolVersionStatsEpds } from 'services/api/toolsQueries';
import { ToolVersionStatsType } from 'types/tools/stats/ToolVersionStatsType';
import ToolVersionStatsListItem from './VersionStatsListItem';
import { EpdLinks } from 'routes/EpdRoutes';

interface Props {
  toolId: string;
  versionOrd: number;
  type: ToolVersionStatsType;
  onHide(): void;
  skeletonsCount: number;
  disableLinks: boolean;
}

const ToolVersionStatsList: React.FC<Props> = ({ toolId, versionOrd, type, onHide, skeletonsCount, disableLinks }) => {
  const epdsQuery = useToolVersionStatsEpds(toolId, versionOrd, type);

  if (epdsQuery.error) {
    const message = epdsQuery.error instanceof Error ? epdsQuery.error.message : 'Unknown error';
    return `Failed to load EPDs: ${message}`;
  }

  const epds = epdsQuery.data;
  if (!epds) {
    return Array(skeletonsCount)
      .fill(0)
      .map((_, i) => <Skeleton key={i} height="48px" />);
  }

  return epds.map((epd) => (
    <ToolVersionStatsListItem
      key={epd.id}
      href={
        type === ToolVersionStatsType.PUBLISHED_EPD_VERSIONS
          ? EpdLinks.epdVersionHistory(epd.id, epd.epdVersionId!)
          : EpdLinks.epd(epd.id)
      }
      onClick={onHide}
      text={epd.registrationNumber}
      disabled={disableLinks}
    />
  ));
};

export default ToolVersionStatsList;
